module.exports = __webpack_public_path__ + "img/common-question-detail-bg.49a7d850.png";